"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = exports.ValueItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ValueItem = function ValueItem(_ref) {
  var isPlaceholder = _ref.isPlaceholder,
      children = _ref.children,
      remove = _ref.remove,
      edit = _ref.edit,
      customTheme = _ref.customTheme,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var theme = _objectSpread(_objectSpread({}, (0, _withTheme.useTheme)()), customTheme);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n        ".concat(isPlaceholder ? theme.textLight : "".concat(disabled ? theme.accent2 : !(remove || edit) ? "" : theme.menuBgActive, "\n            mr-1 pl-2 ").concat(!disabled && (remove || edit) ? "pr-1" : "pr-2", "\n          "), "\n        ").concat(theme.itemText, "\n        whitespace-pre-wrap mt-1 relative flex items-center\n      ")
  }, children, isPlaceholder || disabled || !edit ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            ".concat(theme.menuBgActive, " ").concat(theme.menuBgActiveHover, " ").concat(theme.textContrast, "\n            ml-2 p-1 flex justify-center items-center rounded cursor-pointer\n          "),
    onClick: edit
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8",
    height: "8"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "0",
    y1: "6",
    x2: "4",
    y2: "2",
    style: {
      stroke: "currentColor",
      strokeWidth: 2
    }
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "4",
    y1: "2",
    x2: "8",
    y2: "6",
    style: {
      stroke: "currentColor",
      strokeWidth: 2
    }
  }))), isPlaceholder || disabled || !remove ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            ".concat(theme.menuBgActive, " ").concat(theme.menuBgActiveHover, " ").concat(theme.textContrast, "\n            ").concat(edit ? "ml-1" : "ml-2", " p-1 flex justify-center items-center rounded cursor-pointer\n          "),
    onClick: remove
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8",
    height: "8"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x2: "8",
    y2: "8",
    style: {
      stroke: "currentColor",
      strokeWidth: 2
    }
  }), /*#__PURE__*/_react["default"].createElement("line", {
    y1: "8",
    x2: "8",
    style: {
      stroke: "currentColor",
      strokeWidth: 2
    }
  }))));
};

exports.ValueItem = ValueItem;

var ValueContainer = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      hasFocus = _ref2.hasFocus,
      large = _ref2.large,
      small = _ref2.small,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      customTheme = _ref2.customTheme,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className,
      props = _objectWithoutProperties(_ref2, ["children", "hasFocus", "large", "small", "disabled", "customTheme", "className"]);

  var theme = _objectSpread(_objectSpread({}, (0, _withTheme.useTheme)()), customTheme);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    ref: ref,
    className: "\n        w-full flex flex-row flex-wrap\n        ".concat(disabled ? "".concat(theme.inputBgDisabled, " ").concat(theme.inputBorderDisabled) : hasFocus ? "".concat(theme.inputBgFocus, " ").concat(theme.inputBorderFocus) : "".concat(theme.inputBg, " ").concat(theme.inputBorder), "\n        ").concat(large ? "pt-1 pb-2 px-4" : small ? "pb-1 px-1" : "pb-1 px-2", "\n        ").concat(large ? theme.textLarge : small ? theme.textSmall : theme.textBase, "\n        ").concat(className, "\n      ")
  }), children);
});

exports.ValueContainer = ValueContainer;